/* Xem nhanh — bấm "Xem tùy chọn" trên thẻ sản phẩm thì mở popup chọn biến thể
   ngay tại chỗ, thay vì bắn thẳng sang trang chi tiết rồi phải bấm quay lại.

   VÌ SAO KHÔNG DÙNG <quick-add-modal> CÓ SẴN CỦA THEME:
   nó tải NGUYÊN trang chi tiết rồi cắt lấy khúc giữa — đo trên site thật là
   348 KB cho một sản phẩm. Ở đây gọi /products/<handle>.js: 15 KB, đã đủ mọi
   thứ cần (biến thể, giá, ảnh, còn/hết hàng). Nhẹ hơn 23 lần cho đúng một việc
   là chọn nhanh, và nội dung popup do mình dựng nên gọn đúng mức cần.

   KHÔNG CÓ JS VẪN DÙNG ĐƯỢC: nút trên thẻ trang chủ vẫn là <a> trỏ sang trang
   chi tiết, còn thẻ ở trang danh mục vẫn rơi về popup gốc của theme. Popup này
   chỉ là lớp tăng cường; mạng lỗi giữa chừng thì tự chuyển sang trang chi tiết
   chứ không để khách bấm vào khoảng không. */
(function () {
  'use strict';

  var CACHE = {};   // đường dẫn -> { t: lúc lấy, p: dữ liệu }
  var HAN_CACHE = 180000;  // 3 phút. Để lâu hơn thì tồn kho trong popup lạc hậu
  var root = null;  // khung popup, dựng một lần rồi dùng lại
  var st = null;    // { p, sel: [], qty, url }
  var lastFocus = null;

  /* Số thứ tự phiên mở. Mọi phản hồi mạng về sau đều phải khớp số này mới
     được dùng. Không có nó thì: mở sản phẩm A (mạng chậm) → đóng → mở sản
     phẩm B (có sẵn trong cache, hiện ngay) → phản hồi của A về sau và VẼ ĐÈ
     lên popup đang hiện B. Khách bấm mua là mua nhầm hàng. */
  var phien = 0;

  /* ---------- tiện ích ---------- */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* Giá trong /products/*.js là ĐƠN VỊ NHỎ NHẤT (533.000₫ trả về 53300000),
     khác với /search/suggest.json trả thẳng đồng — chia 100 rồi mới định dạng. */
  function money(minor) {
    var n = Math.round(Number(minor) / 100);
    if (!isFinite(n)) return '';
    try { return new Intl.NumberFormat('vi-VN').format(n) + '₫'; }
    catch (e) { return n.toLocaleString('vi-VN') + '₫'; }
  }

  function img(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- dữ liệu ---------- */

  function load(url) {
    var key = url.split('?')[0].split('#')[0];
    var c = CACHE[key];
    // Có hạn dùng: giữ mãi thì khách mở tab nửa tiếng rồi xem lại vẫn thấy
    // "Còn hàng" cho mẫu vừa bán hết, bấm mua mới nhận lỗi
    if (c && (nowMs() - c.t) < HAN_CACHE) return Promise.resolve(c.p);
    return fetch(key + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function (p) { CACHE[key] = { t: nowMs(), p: p }; return p; });
  }

  function nowMs() {
    return (window.performance && performance.now) ? performance.now() : Date.now();
  }

  /* Tên tuỳ chọn hiển thị bằng tiếng Việt. Phải khớp y hệt snippet
     egr-option-name.liquid (trang chi tiết dùng snippet đó) — hai nơi lệch chữ
     là khách tưởng hai sản phẩm khác nhau.
     Chỉ đổi chữ đọc lên màn hình, tên gửi lên Shopify vẫn là tên gốc.
     Cố ý bỏ qua "Quantity": dịch thành "Số lượng" sẽ đụng ngay ô tăng giảm số
     lượng thật ở ngay dưới. */
  var TEN_TUY_CHON = {
    'color': 'Màu sắc', 'colour': 'Màu sắc',
    'band color': 'Màu dây', 'band colour': 'Màu dây',
    'size': 'Kích thước', 'material': 'Chất liệu', 'style': 'Kiểu dáng',
    'capacity': 'Dung tích', 'version': 'Phiên bản', 'model': 'Mẫu',
    'type': 'Loại'
  };

  function tenTuyChon(name) {
    var k = String(name == null ? '' : name).trim().toLowerCase();
    return TEN_TUY_CHON[k] || String(name).trim();
  }

  /* Danh sách tuỳ chọn. Shop cũ trả options là mảng chuỗi, shop mới trả mảng
     object {name, values} — đỡ cả hai để không phụ thuộc phiên bản. */
  function optionList(p) {
    return (p.options || []).map(function (o, i) {
      if (typeof o === 'string') {
        var seen = {}, vals = [];
        p.variants.forEach(function (v) {
          var x = v['option' + (i + 1)];
          if (x != null && !seen[x]) { seen[x] = 1; vals.push(x); }
        });
        return { name: o, values: vals };
      }
      return { name: o.name, values: o.values || [] };
    });
  }

  function variantFor(sel) {
    var vs = st.p.variants;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i], ok = true;
      for (var k = 0; k < sel.length; k++) {
        if (v['option' + (k + 1)] !== sel[k]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function current() { return variantFor(st.sel); }

  /* Một giá trị bị coi là không chọn được khi ghép với các lựa chọn hiện tại
     thì không ra biến thể nào còn hàng (kể cả không ra biến thể nào cả). */
  function valueOk(oi, val) {
    var probe = st.sel.slice();
    probe[oi] = val;
    var v = variantFor(probe);
    return !!(v && v.available);
  }

  function qtyMin() {
    var v = current();
    var r = v && v.quantity_rule;
    return (r && r.min) || 1;
  }

  function qtyStep() {
    var v = current();
    var r = v && v.quantity_rule;
    return (r && r.increment) || 1;
  }

  function qtyMax() {
    var v = current();
    var r = v && v.quantity_rule;
    return (r && r.max) || null;
  }

  /* ---------- dựng khung ---------- */

  function ensure() {
    if (root) return root;
    root = document.createElement('div');
    root.className = 'egr-qv';
    root.setAttribute('hidden', '');
    root.innerHTML =
      '<div class="egr-qv__ovl" data-qv-close></div>' +
      '<div class="egr-qv__box" role="dialog" aria-modal="true" aria-label="Xem nhanh sản phẩm">' +
        '<button type="button" class="egr-qv__x" data-qv-close aria-label="Đóng">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="egr-qv__in"></div>' +
      '</div>';
    document.body.appendChild(root);

    root.addEventListener('click', onClick);
    /* Gõ thì chỉ GHI NHẬN, chưa kẹp — kẹp ngay lúc gõ sẽ giành phím với khách
       (gõ "12" bị sửa thành "1" ngay sau ký tự đầu). Rời ô mới kẹp và ghi lại. */
    root.addEventListener('input', function (e) {
      if (e.target.matches('[data-qv-qty]')) docOSoLuong();
    });
    // blur không nổi bọt nên phải bắt ở giai đoạn capture
    root.addEventListener('blur', function (e) {
      if (e.target.matches('[data-qv-qty]')) { docOSoLuong(); clampQty(); }
    }, true);
    document.addEventListener('keydown', onKey);
    return root;
  }

  function skeleton() {
    root.querySelector('.egr-qv__in').innerHTML =
      '<div class="egr-qv__load"><span class="egr-qv__spin" aria-hidden="true"></span>Đang tải sản phẩm…</div>';
  }

  function paint() {
    var p = st.p;
    var opts = optionList(p);
    var single = opts.length === 1 && opts[0].values.length === 1;

    var html =
      '<div class="egr-qv__media">' +
        /* Không có ảnh thì vẽ ô giữ chỗ, KHÔNG in <img src=""> — trình duyệt
           sẽ hiện biểu tượng ảnh vỡ giữa popup */
        (p.featured_image
          ? '<img class="egr-qv__img" alt="' + esc(p.title) + '" src="' + esc(img(p.featured_image, 640)) + '" width="640" height="640">'
          : '<span class="egr-qv__noimg">Hình ảnh sẽ được cập nhật</span>') +
      '</div>' +
      '<div class="egr-qv__info">' +
        (p.vendor ? '<p class="egr-qv__vendor">' + esc(p.vendor) + '</p>' : '') +
        '<h2 class="egr-qv__title"><a href="' + esc(st.url) + '">' + esc(p.title) + '</a></h2>' +
        /* aria-live: giá và tồn kho đổi khi khách chọn mẫu khác. Không có nó
           thì người dùng trình đọc màn hình bấm chọn xong không hề biết giá
           vừa nhảy hay mẫu đó đã hết hàng. */
        '<div class="egr-qv__prices" data-qv-prices aria-live="polite"></div>' +
        (single ? '' : '<div class="egr-qv__opts">' + opts.map(function (o, i) {
          return '<div class="egr-qv__opt">' +
            '<p class="egr-qv__optname">' + esc(tenTuyChon(o.name)) + ': <b data-qv-oname="' + i + '"></b></p>' +
            '<div class="egr-qv__vals">' + o.values.map(function (val) {
              return '<button type="button" class="egr-qv__val" data-qv-o="' + i + '" data-qv-v="' + esc(val) + '">' + esc(val) + '</button>';
            }).join('') + '</div>' +
          '</div>';
        }).join('') + '</div>') +
        // Cố ý KHÔNG hiện SKU: đó là mã kho nội bộ, khách không dùng tới
        '<div class="egr-qv__row">' +
          '<span class="egr-qv__stock" data-qv-stock aria-live="polite"></span>' +
        '</div>' +
        '<div class="egr-qv__qtywrap">' +
          '<span class="egr-qv__qtylb">Số lượng</span>' +
          '<div class="egr-qv__qty">' +
            '<button type="button" data-qv-step="-1" aria-label="Giảm số lượng">−</button>' +
            '<input type="text" inputmode="numeric" data-qv-qty value="1" aria-label="Số lượng">' +
            '<button type="button" data-qv-step="1" aria-label="Tăng số lượng">+</button>' +
          '</div>' +
        '</div>' +
        /* role="alert" đặt SẴN trong HTML chứ không gắn lúc hiện lỗi: đây là
           chỗ in thông báo của Shopify kiểu "chỉ còn 2 sản phẩm trong kho" —
           thông tin quan trọng nhất trong luồng mua mà lại là thứ duy nhất
           không được xướng lên. */
        '<p class="egr-qv__err" data-qv-err role="alert" hidden></p>' +
        '<div class="egr-qv__acts">' +
          '<button type="button" class="egr-qv__add" data-qv-add>' +
            '<span data-qv-addtx>Thêm vào giỏ hàng</span>' +
            '<span class="egr-qv__spin egr-qv__spin--btn" aria-hidden="true" hidden></span>' +
          '</button>' +
          '<a class="egr-qv__more" href="' + esc(st.url) + '">Xem chi tiết' +
            '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>' +
          '</a>' +
        '</div>' +
      '</div>';

    root.querySelector('.egr-qv__in').innerHTML = html;
    sync();
  }

  /* Cập nhật những phần đổi theo biến thể. Không dựng lại cả popup để nút đang
     được focus không bị thay mất — bấm bàn phím vẫn chọn tiếp được. */
  function sync() {
    var box = root.querySelector('.egr-qv__in');
    var v = current();
    var opts = optionList(st.p);

    box.querySelectorAll('[data-qv-oname]').forEach(function (el) {
      el.textContent = st.sel[Number(el.getAttribute('data-qv-oname'))] || '';
    });

    box.querySelectorAll('.egr-qv__val').forEach(function (b) {
      var oi = Number(b.getAttribute('data-qv-o'));
      var val = b.getAttribute('data-qv-v');
      var on = st.sel[oi] === val;
      var duoc = valueOk(oi, val);
      b.classList.toggle('on', on);
      b.classList.toggle('is-off', !duoc);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      /* Toàn bộ thông tin "mẫu này hết hàng" đang nằm ở một vạch gạch chéo vẽ
         bằng gradient — trình đọc màn hình không thấy, và chế độ tương phản
         cao của Windows bỏ luôn background-image nên vạch đó biến mất. Phải
         nói bằng thuộc tính. */
      b.setAttribute('aria-disabled', duoc ? 'false' : 'true');
    });

    var prices = box.querySelector('[data-qv-prices]');
    if (prices) {
      var cur = v ? v.price : st.p.price;
      var cap = v ? v.compare_at_price : st.p.compare_at_price;
      var h = '<span class="egr-qv__price">' + money(cur) + '</span>';
      if (cap && cap > cur) {
        h += '<span class="egr-qv__old">' + money(cap) + '</span>' +
             '<span class="egr-qv__save">Tiết kiệm ' + money(cap - cur) + '</span>';
      }
      prices.innerHTML = h;
    }

    var stock = box.querySelector('[data-qv-stock]');
    if (stock) {
      if (!v) {
        stock.textContent = 'Không còn mẫu này';
        stock.className = 'egr-qv__stock is-out';
      } else if (v.available) {
        stock.textContent = 'Còn hàng';
        stock.className = 'egr-qv__stock';
      } else {
        stock.textContent = 'Hết hàng';
        stock.className = 'egr-qv__stock is-out';
      }
    }

    var im = box.querySelector('.egr-qv__img');
    var src = (v && v.featured_image && v.featured_image.src) || st.p.featured_image;
    if (im && src) {
      var next = img(src, 640);
      if (im.getAttribute('src') !== next) im.setAttribute('src', next);
    }

    clampQty();

    var add = box.querySelector('[data-qv-add]');
    var tx = box.querySelector('[data-qv-addtx]');
    if (add && tx) {
      var ok = !!(v && v.available);
      /* Nếu nút đang được focus mà ta disable nó, trình duyệt hất focus về
         <body> — lúc đó bẫy Tab so activeElement với đầu/cuối đều trượt, và
         Tab kế tiếp chạy ra trang nền sau lớp phủ. Dời focus vào hộp thoại
         trước khi khoá nút. */
      if (!ok && document.activeElement === add) {
        var box2 = root.querySelector('.egr-qv__box');
        if (box2) { box2.setAttribute('tabindex', '-1'); box2.focus(); }
      }
      add.disabled = !ok;
      tx.textContent = ok ? 'Thêm vào giỏ hàng' : 'Hết hàng';
    }

    hideErr();
  }

  /* Kéo số lượng về khoảng hợp lệ của biến thể.
     LÀM TRÒN XUỐNG chứ không phải làm tròn gần nhất: với quy tắc
     {min:1, increment:5, max:9}, bấm "+" hai lần ra 11 → kẹp về 9 → làm tròn
     gần nhất lại đẩy NGƯỢC lên 11, vượt trần, và Shopify trả lỗi. Làm tròn
     xuống rồi kẹp lại lần nữa thì không có đường nào vượt được max. */
  function clampQty() {
    var min = qtyMin(), step = qtyStep(), max = qtyMax();
    var q = st.qty;
    if (!isFinite(q) || q < min) q = min;
    if (max && q > max) q = max;
    if (step > 1) q = min + Math.floor((q - min) / step) * step;
    if (max && q > max) q = min + Math.floor((max - min) / step) * step;
    if (q < min) q = min;
    st.qty = q;
    var input = root.querySelector('[data-qv-qty]');
    if (input) input.value = String(q);
  }

  /* Đọc con số khách TỰ GÕ vào ô. Thiếu hàm này thì ô số lượng chỉ là đồ
     trang trí: khách gõ 5, bấm thêm vào giỏ, giỏ nhận đúng 1 món và không có
     một lời cảnh báo nào — vì st.qty chỉ đổi qua hai nút +/−. */
  function docOSoLuong() {
    if (!st || !root) return;
    var input = root.querySelector('[data-qv-qty]');
    if (!input) return;
    var n = parseInt(String(input.value).replace(/[^\d]/g, ''), 10);
    if (isFinite(n) && n > 0) st.qty = n;
  }

  function showErr(msg) {
    var el = root.querySelector('[data-qv-err]');
    if (!el) return;
    el.className = 'egr-qv__err';   // gỡ trạng thái "đã thêm" nếu còn
    el.textContent = msg;
    el.removeAttribute('hidden');
  }

  function hideErr() {
    var el = root.querySelector('[data-qv-err]');
    if (el) el.setAttribute('hidden', '');
  }

  /* Thêm được hàng nhưng KHÔNG mở được ngăn giỏ (trang không render
     <cart-drawer>, hoặc renderContents văng lỗi). Phải nói ra, kèm lối đi
     tiếp — im lặng thì khách tưởng hỏng và bấm thêm mấy lần nữa. */
  function baoDaThem() {
    var el = root.querySelector('[data-qv-err]');
    if (!el) return;
    el.textContent = '';
    el.className = 'egr-qv__err is-ok';
    el.appendChild(document.createTextNode('Đã thêm vào giỏ. '));
    var a = document.createElement('a');
    a.href = (window.routes && window.routes.cart_url) || '/cart';
    a.textContent = 'Xem giỏ hàng';
    el.appendChild(a);
    el.removeAttribute('hidden');
  }

  /* ---------- mở / đóng ---------- */

  function open(url, opener) {
    if (!url) return;
    var toi = ++phien;
    lastFocus = opener || document.activeElement;
    ensure();
    root.removeAttribute('hidden');
    document.documentElement.classList.add('egr-qv-on');
    skeleton();
    // requestAnimationFrame để trình duyệt kịp vẽ trạng thái đóng trước khi
    // gắn .is-open, nếu không hiệu ứng trượt lên sẽ bị nhảy cóc
    requestAnimationFrame(function () { root.classList.add('is-open'); });

    load(url).then(function (p) {
      // Không phải phiên hiện tại thì bỏ, đừng vẽ đè lên sản phẩm khác
      if (toi !== phien || !root || root.hasAttribute('hidden')) return;
      var first = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available) { first = p.variants[i]; break; }
      }
      if (!first) first = p.variants[0];
      var n = (p.options || []).length || 1;
      var sel = [];
      for (var k = 0; k < n; k++) sel.push(first ? first['option' + (k + 1)] : null);

      st = { p: p, url: url, sel: sel, qty: 1 };
      st.qty = qtyMin();
      paint();
      var f = root.querySelector('.egr-qv__val.on, [data-qv-add]');
      if (f) f.focus();
    }).catch(function (e) {
      if (toi !== phien) return;
      /* Ghi log TRƯỚC khi chuyển trang. .catch này nằm sau .then nên nó nuốt
         cả lỗi ném ra từ paint()/sync() chứ không riêng lỗi mạng — không log
         thì một sản phẩm dữ liệu lạ sẽ biểu hiện thành "bấm xem nhanh là
         nhảy trang", console sạch trơn, không ai lần ra được. */
      if (window.console && console.error) console.error('[egr-quickview] hỏng khi mở ' + url, e);
      // Trả khách về đúng hành vi cũ: sang trang chi tiết
      window.location.href = url;
    });
  }

  function close() {
    if (!root || root.hasAttribute('hidden')) return;
    // Tăng phiên để mọi phản hồi đang bay không vẽ lại vào popup đã đóng
    phien++;
    root.classList.remove('is-open');
    root.setAttribute('hidden', '');
    document.documentElement.classList.remove('egr-qv-on');
    st = null;
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  function onKey(e) {
    if (!root || root.hasAttribute('hidden')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    // Giữ tiêu điểm trong popup, không cho Tab chạy ra nền phía sau
    var f = root.querySelectorAll('a[href], button:not([disabled]), input');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------- thao tác trong popup ---------- */

  function onClick(e) {
    if (e.target.closest('[data-qv-close]')) { close(); return; }

    var val = e.target.closest('.egr-qv__val');
    if (val && st) {
      st.sel[Number(val.getAttribute('data-qv-o'))] = val.getAttribute('data-qv-v');
      sync();
      return;
    }

    var step = e.target.closest('[data-qv-step]');
    if (step && st) {
      st.qty += Number(step.getAttribute('data-qv-step')) * qtyStep();
      clampQty();
      return;
    }

    if (e.target.closest('[data-qv-add]')) { addToCart(); }
  }

  function addToCart() {
    var v = current();
    if (!v || !v.available) return;

    var btn = root.querySelector('[data-qv-add]');
    var spin = root.querySelector('.egr-qv__spin--btn');
    btn.disabled = true;
    if (spin) spin.removeAttribute('hidden');
    hideErr();

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var body = { items: [{ id: v.id, quantity: st.qty }] };
    // Xin kèm HTML các section giỏ hàng để mở được ngăn giỏ ngay, giống hệt
    // đường mà nút "Thêm vào giỏ" của theme đang đi
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    var toi = phien;   // phiên lúc bấm, để bỏ qua phản hồi lạc hậu
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(base + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        /* Xét r.ok chứ không nhảy thẳng vào json(): Shopify chặn bot (430),
           lỗi 5xx hay trang chuyển hướng đều trả HTML, json() sẽ reject và
           rơi vào catch mạng — khách được bảo "thử lại" cho một thứ thử lại
           bao nhiêu lần cũng hỏng. */
        if (!r.ok && r.status !== 422) {
          throw new Error('HTTP ' + r.status);
        }
        return r.json();
      })
      .then(function (res) {
        // Khách đã đóng popup rồi mở sản phẩm khác -> đừng đụng vào popup mới
        if (toi !== phien) return;

        if (res && res.status && res.status !== 200) {
          showErr(res.description || res.message || 'Không thêm được sản phẩm.');
          unlock();
          return;
        }

        /* CHỈ đóng popup KHI ngăn giỏ đã render xong. Bản trước đóng TRƯỚC:
           trên trang không có <cart-drawer> (nhánh Dịch vụ trong theme.liquid
           không render nó) hoặc khi renderContents văng lỗi, khách bấm xong
           thấy popup biến mất, không ngăn giỏ, không thông báo, không con số
           nào nhúc nhích — hàng đã vào giỏ thật mà khách tưởng hỏng nên bấm
           lại mấy lần và mua thừa. */
        var xong = false;
        if (cart && typeof cart.renderContents === 'function' && res && res.sections) {
          try {
            /* Phải gỡ .is-empty TRƯỚC khi mở ngăn giỏ. Lúc mở, cart-drawer.js
               chạy: giỏ còn cờ is-empty thì nó đi tìm .drawer__inner-empty —
               mà khối đó vừa bị thay bằng giỏ có hàng nên trả về null, rồi
               trapFocus(null) văng TypeError, hỏng bẫy tiêu điểm bàn phím.
               product-form.js của theme cũng gỡ cờ này, chỉ là gỡ trong
               finally nên vô tình kịp trước. Ở đây gỡ thẳng cho chắc. */
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            // Để đóng ngăn giỏ xong tiêu điểm quay lại đúng nút vừa bấm
            if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
            cart.renderContents(res);
            xong = true;
          } catch (e) {
            if (window.console && console.error) console.error('[egr-quickview] không mở được ngăn giỏ', e);
          }
        }

        if (xong) { close(); return; }

        // Không mở được ngăn giỏ: GIỮ popup lại và nói thật, đừng để khách đoán
        bumpCount();
        baoDaThem();
        unlock();
      })
      .catch(function (e) {
        if (toi !== phien) return;
        if (window.console && console.error) console.error('[egr-quickview] thêm giỏ hỏng', e);
        showErr('Chưa thêm được sản phẩm, thử lại giúp mình nhé.');
        unlock();
      });

    function unlock() {
      btn.disabled = false;
      if (spin) spin.setAttribute('hidden', '');
    }
  }

  /* Dự phòng khi trang không có ngăn giỏ: tự cập nhật con số trên icon giỏ */
  function bumpCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('.egr-hd__count').forEach(function (el) {
          el.textContent = c.item_count;
        });
      })
      .catch(function () {});
  }

  /* ---------- bắt sự kiện trên thẻ sản phẩm ---------- */

  /* Bắt ở giai đoạn CAPTURE trên document vì:
     — nút "Choose options" của theme có listener riêng mở popup nặng của nó;
       capture chạy trước nên stopPropagation chặn được listener đó.
     — các kệ sản phẩm dựng lại DOM khi đổi tab/lọc, gắn thẳng vào nút sẽ mất. */
  document.addEventListener('click', function (e) {
    /* Ctrl/Cmd/Shift/Alt-click và chuột giữa phải để nguyên cho trình duyệt:
       nút "Xem tùy chọn" là thẻ <a> thật, khách quen mở nhiều tab để so sánh
       vài món. Nuốt hết mọi kiểu bấm là cướp mất thói quen đó. */
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;

    var a = e.target.closest('a.egr-cardcta--opt');
    if (a) {
      e.preventDefault();
      open(a.getAttribute('href'), a);
      return;
    }

    var b = e.target.closest('modal-opener[data-modal^="#QuickAdd"] [data-product-url], .quick-add__submit[data-product-url]');
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      open(b.getAttribute('data-product-url'), b);
    }
  }, true);
})();
